import React, { useEffect, useState } from "react";
import EditItemPage from "../../../../entities/DashboardPage/AccountingModule/EditItem";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../../../api/AuthService";
// eslint-disable-next-line import/default
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../context/AlertContext";

const EditItem = () => {
  const { state } = useLocation();
  const { item } = state || {};
  const [imgUrl, setimgUrl] = useState(item?.images || []);
  const [loading, setLoading] = useState(false);
  const [supplierList, setSupplierList] = useState();
  const [itemList, setItemList] = useState()
  const [ItemData, setItemData] = useState()
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    getSupplierList()
    getItem();
    getOneItemData(item?._id)
  }, [])

  useEffect(() => {
    if (item?.images) {
      setimgUrl(item.images);
    }
  }, [item?.images]);

  const handleUrl = async (data) => {
    try {
      const result = await AuthService.handleImgUrl(data);
      if (result.success) {
        setimgUrl((prev) => [...prev, ...result.data]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleEdit = async (payload, files) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleEditItem(item._id, payload, files);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success")
        navigate("/dashboard/items")
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error")
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error, "success")
    }
  };

  const getSupplierList = async (text, sort, page) => {
    setLoading(true);
    try {
      const result = await AuthService.getSupplier(text, sort, page);
      if (result?.success) {
        setSupplierList(result?.data?.suppliers);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getItem = async (text) => {
    setLoading(true);
    try {
      const result = await AuthService.getItemsList(text);
      if (result?.success) {
        setItemList(result?.data?.items);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {

      setLoading(false);
    }
  };

  const getOneItemData = async (id) => {
    setLoading(true);
    try {
      const result = await AuthService.getOneItem(id);
      if (result?.success) {
        setItemData(result?.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <EditItemPage handleEdit={handleEdit} handleItemList={getItem} itemList={itemList} setimgUrl={setimgUrl} supplierList={supplierList} loading={loading} item={item} imgUrl={imgUrl} handleUrl={handleUrl} ItemData={ItemData} />
  )

}

export default EditItem;
